import { type IGeoreference } from "@interfaces/common/IGeoreference";
import { type ISettings } from "@interfaces/common/ISettings";
import { type ITypeState } from "@interfaces/common/ITypeState";
import { type IAccessibleModule } from "@interfaces/modules/IAccessibleModule";
import { type IPlanStatus } from "@interfaces/modules/IGetModulesResponse";

export class SetTypeState {
  static readonly type = "[Common] Set Type State";
  constructor(public typeStates: ITypeState[]) {}
}

export class SetSettings {
  static readonly type = "[Common] Set Settings";
  constructor(public settings: ISettings) {}
}

export class SetCurrentTenant {
  static readonly type = "[Common] Set Current Tenant";
  constructor(public currentTenant: string | null) {}
}

export class SetSavedRut {
  static readonly type = "[Common] Set Saved Rut";
  constructor(public rut: string) {}
}

export class ClearSavedRut {
  static readonly type = "[Common] Clear Saved Rut";
}

export class SetCurrentTenantBusinessName {
  static readonly type = "[Common] Set Current Tenant Business Name";
  constructor(public businessName: string | null) {}
}

export class SetAccessibleModules {
  static readonly type = "[Common] Set Accessible Modules";
  constructor(public accessibleModules: IAccessibleModule[]) {}
}

export class ClearAccessibleModules {
  static readonly type = "[Common] Clear Accessible Modules";
}

export class SetPlanStatus {
  static readonly type = "[Common] Set Plan Status";
  constructor(public planStatus: IPlanStatus | null) {}
}

export class SetCompanyGeoreference {
  static readonly type = "[Common] Set Company Georeference";
  constructor(public companyGeoreference: IGeoreference) {}
}

export class ClearCompanyGeoreference {
  static readonly type = "[Common] Clear Company Georeference";
}

export class GetFavorites {
  static readonly type = "[Common] Get Favorites";
  constructor(public tenant?: string) {}
}

export class SaveFavorites {
  static readonly type = "[Common] Save Favorites";
  constructor(public favoriteKeys: string[]) {}
}

export class ClearFavorites {
  static readonly type = "[Common] Clear Favorites";
}
